import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../CSS/Global.css';
import './CustomerStyle.css';
import Header from '../Header';
import Sidebar from '../SideBar';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { BadgeCheck, BadgeIndianRupee, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Mail, Phone } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import { useFilter } from '../../FilterContext';
import FilterDrawer from '../FilterDrawer';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';

const Admission = () => {
  const navigate = useNavigate();
  const { globalSearch } = useSearch();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isImportOpen, setImportOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const url = process.env.REACT_APP_LINK
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const { entriesPerPage, sortOrder, showDrawer, setShowDrawer, customDate } = useFilter();
  const [load, setLoad] = useState(false)
   const token = decryptToken("accessToken") || ""

  const fetchCustomers = async () => {
    try {
      setLoad(true); // Start loading
      const response = await fetch(`${url}/admission/alladmin/${isLoggedIn.main_id}`);
      const data = await response.json();
      // const parsedCustomers = data.map((customer) => ({
      //   ...customer,
      //   billingAddress: customer.billingAddress ? JSON.parse(customer.billingAddress) : {},
      //   shippingAddress: customer.shippingAddress ? JSON.parse(customer.shippingAddress) : {},
      //   contact: customer.contact ? JSON.parse(customer.contact) : [],
      // }));
      console.log("Customer data", data);
      setCustomers(data.user);
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoad(false); // Stop loading after everything is done
    }
  };


  useEffect(() => {
    fetchCustomers();
  }, []);

  // 1. Filter by date
  let processedCustomers = [...customers];

  console.log(processedCustomers)
  if (customDate.from || customDate.to) {
    processedCustomers = processedCustomers.filter((customer) => {
      const createdAt = new Date(customer.createdAt);
      const from = customDate.from ? new Date(customDate.from) : null;
      const to = customDate.to ? new Date(customDate.to) : null;

      return (!from || createdAt >= from) && (!to || createdAt <= to);
    });
  }

  // 2. Sort by createdAt
  processedCustomers.sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });


  const filteredCustomers = processedCustomers.filter((customer) =>
    (customer.customerName || '').toLowerCase().includes(globalSearch.toLowerCase()) ||
    (customer.companyName || '').toLowerCase().includes(globalSearch.toLowerCase()) ||
    (customer.email || '').toLowerCase().includes(globalSearch.toLowerCase()) ||
    (customer.phone1 || '').toLowerCase().includes(globalSearch.toLowerCase()) ||
    (customer.gstNumber || '').toLowerCase().includes(globalSearch.toLowerCase()) ||
    (customer.remarks || '').toLowerCase().includes(globalSearch.toLowerCase())
  );

  const indexOfLastCustomer = currentPage * entriesPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - entriesPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);
  const totalPages = Math.ceil(filteredCustomers.length / entriesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleSearch = (event) => setSearchQuery(event.target.value);
  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);
  const toggleImport = () => setImportOpen(!isImportOpen);
  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  };

  const handleDelete = async (customerId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This customer will be permanently deleted!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${url}/admission/${customerId}`, {
            method: 'DELETE',
            headers:{
              "Content-Type":"application/json",
              "Authorization":`Bearer ${token}`
            }
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.message || 'Failed to delete');
          }

          Swal.fire('Deleted!', 'Admission has been deleted.', 'success');
          setCustomers(customers.filter(c => c.id !== customerId));
        } catch (error) {
          console.error('Delete error:', error.message);
          Swal.fire('Error!', `Failed to delete customer. ${error.message}`, 'error');
        }
      }
    });
  };


  const handleEdit = (customer) => {
    navigate('/edit-admission', { state: customer });

  };

  const handleStatusChange = async (e, customer) => {
    e.stopPropagation();
    const newStatus = e.target.value;

    // Optimistic UI update
    setCustomers(prev =>
      prev.map(c =>
        c.id === customer.id ? { ...c, status: newStatus } : c
      )
    );

    try {
      const res = await fetch(`${url}/admission/status/${customer.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (!res.ok) {
        throw new Error("Failed to update status");
      }

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Status updated successfully",
        timer: 1200,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error(error);

      // Rollback on error
      setCustomers(prev =>
        prev.map(c =>
          c.id === customer.id ? { ...c, status: customer.status } : c
        )
      );

      Swal.fire("Error", "Failed to update status", "error");
    }
  };


  // const handleDelete=()=>{

  // }


  const SkeletonLoader = () => (
    <div>
      {Array(10).fill('').map((_, index) => (
        <div className="skeleton-row" key={index}>
          {[...Array(5)].map((_, i) => <div className="skeleton" key={i}></div>)}
        </div>
      ))}
    </div>
  );

  if (load) {
    return (
      <Loader />
    );
  }

  return (
    <>

      <div >
        <div className="customers-header">
          <div className="customer-dropdown">
            <p className="dashboard-title" onClick={toggleDropdown}>
              All Admission <i className={`fa-solid fa-chevron-down ${isDropdownOpen ? 'rotate' : ''}`}></i>
            </p>
          </div>

          <div className="customer-warning-new-hamburger-help">
            {/* <p className="customer-warning-text">
              <span><i className="fa-solid fa-triangle-exclamation"></i> Update GST details</span> for 520 customers
            </p> */}
            <div className="customer-new">
              <Link to='/add-admission'>
                <button className="oms-add-btn"><i className="fa-solid fa-plus"></i> New</button>
              </Link>
            </div>
            <div className="filter-controls">
              <button onClick={() => setShowDrawer(true)} className="more-filters-btn">
                <i className="fa-solid fa-sliders"></i> Filters
              </button>
            </div>
            {/* <div className="import-hamburger" onClick={toggleImport}>
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </div>
            {isImportOpen && (
              <div className="import-ul">
                <ul>
                  <li><Link to='/admission-import'><i className="fa-solid fa-file-arrow-down"></i> Import Customers</Link></li>
                  <li><Link to='/export-admission'><i className="fa-solid fa-file-arrow-up"></i> Export Customers</Link></li>
                  <li onClick={handleRefresh}><i className="fa-solid fa-rotate"></i> Refresh List</li>
                </ul>
              </div>
            )} */}
          </div>
        </div>

        {/* <div className="filter-search">
          <div className="filter-search-input">
            <input type="search" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
            <i className="fa fa-search"></i>
          </div>
        </div> */}

        {/* <div className="customer-table">
          {loading ? (
            <SkeletonLoader />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Company Name</th>
                  <th>Email</th>
                  <th>Work Phone</th>
                  <th>GST Number</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {
                  currentCustomers.length > 0 ? (

                    currentCustomers.map((customer, index) => (
                      <tr key={index}>
                        <td>{customer.customerName}</td>
                        <td>{customer.companyName}</td>
                        <td>{customer.email}</td>
                        <td>{customer.phone1}</td>
                        <td>{customer.gstNumber}</td>
                        <td>{new Date(customer.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
                        <td>
                          <button onClick={() => handleEdit(customer)} className="edit-btn">
                            <i className="fa-solid fa-pen"></i>
                          </button>
                          <button onClick={() => handleDelete(customer.id)} className="delete-btn" style={{ marginLeft: '8px' }}>
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: 'center' }}>No data found.</td>
                    </tr>
                  )}
              </tbody>
            </table>
          )}
        </div> */}
        {
          currentCustomers.length > 0 ? (
            currentCustomers.map((customer, index) => (
              <div
                className="ecom-customer-card"
                key={customer.id || index}
              // onClick={() => navigate(`/admission-detail/${customer.payment_id}`)}
              // style={{ cursor: "pointer" }}
              >
                {/* {customer.customerType && (
                  <div className="ecom-customer-time">
                    {customer.customerType}
                  </div>
                )} */}

                <div className="admission-maindivflex">
                  <div
                    className="ecom-customer-actions"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <select className="ecom-status-select" value={customer.status}  onChange={(e) => handleStatusChange(e, customer)}>
                      {/* <option value="Active">Active</option> */}
                      <option value="Deactive">Failed</option>
                      <option value="Paid">Paid</option>
                      {/* <option value="Failed">Failed</option> */}
                    </select>

                    <button className="ecom-edit-btn"
                      onClick={() => {
                        handleEdit(customer)
                      }}
                    >
                      <i className="fa-solid fa-pen"></i>
                    </button>

                    <button className="ecom-delete-btn"
                      onClick={() => handleDelete(customer.id)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                    {/* <div className="admission-add-btn-wrap">
                      <button ><i className="fa-solid fa-plus"></i></button>
                    </div> */}
                  </div>


                </div>



                {customer.name && (
                  <h2 className="ecom-customer-name">{customer.name}</h2>
                )}

                {customer.mobile && (
                  <div className="ecom-customer-row">
                    <Phone className="ecom-customer-icon" strokeWidth={2} />
                    <span>{customer.mobile}</span>
                  </div>
                )}

                {customer.email && (
                  <div className="ecom-customer-row">
                    <Mail className="ecom-customer-icon" strokeWidth={2} />
                    <span>{customer.email}</span>
                  </div>
                )}
                {customer.status && (
                  <div className={`ecom-customer-row${customer.status}`}>
                    <BadgeIndianRupee className={`ecom-customer-icon${customer.status}`} strokeWidth={2} />
                    <span>{customer.status === "Paid" ? "Paid" : "Failed"}</span>
                  </div>
                )}

                {customer.admission_id && (
                  <div className="ecom-customer-row">
                    <BadgeCheck className="ecom-customer-icon" strokeWidth={2} />
                    <span>{customer.admission_id}</span>
                  </div>
                )}

              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", margin: "50px" }}>No customers found.</p>
          )
        }



        {totalPages > 1 && (

          <div className="pagination">
            {/* First Page */}
            <button
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              className="pagination-chev-btn"
            >
              <ChevronsLeft size={18} />
            </button>

            {/* Previous Page */}
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-chev-btn"
            >
              <ChevronLeft size={18} />
            </button>

            {/* Current Page Number Only */}
            <button className="pagination-btn active">
              {currentPage}
            </button>

            {/* Next Page */}
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-chev-btn"
            >
              <ChevronRight size={18} />
            </button>

            {/* Last Page */}
            <button
              onClick={() => paginate(totalPages)}
              disabled={currentPage === totalPages}
              className="pagination-chev-btn"
            >
              <ChevronsRight size={18} />
            </button>
          </div>
        )}

      </div>
      <FilterDrawer />
    </>
  );
};

export default Admission;
